/** THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
export const RADIUS = {
  'number-radius-none': '0rem',
  'number-radius-3xsmall': '0.125rem',
  'number-radius-2xsmall': '0.25rem',
  'number-radius-xsmall': '0.375rem',
  'number-radius-small': '0.5rem',
  'number-radius-medium': '0.625rem',
  'number-radius-large': '0.75rem',
  'number-radius-Xlarge': '1rem',
  'number-radius-2xlarge': '1.25rem',
  'number-radius-3xlarge': '1.5rem',
  'number-radius-round': '9999rem'
}
